export default __webpack_public_path__ + "static/media/flag-uruguay.9ee721a6.svg";